/**
 * Safety cap used when requesting every row matching the applied filters for
 * an Excel export (no pagination). Must stay in sync with MAX_EXPORT_PAGE_SIZE
 * in the backend (dashboard-backend/src/config/pagination.ts).
 */
export const MAX_EXPORT_PAGE_SIZE = 5000;
